






import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { RenderMenuMixin } from '@/mixins';
import { AcgnStaticsMenu, AcgnStatisticDetail } from '@/components';

@Component({
  components: {
    AcgnStaticsMenu,
    AcgnStatisticDetail
  },
  mixins: [RenderMenuMixin]
})

/**
 * 项目数据 -（数据明细）
 */
export default class StatisticComicDetail extends Vue {

  private comicId: number = 0; // 漫画id

  private created() {
    this.comicId = parseInt(this.$route.params.id, 0);
  }

  // 渲染左侧菜单
  private renderMenu() {
    return (
      <acgn-statics-menu type="comic" comicId={this.comicId}></acgn-statics-menu>
    );
  }
}
